/**
 * Règle française : singulier sous 2 (« 0 jour », « 1,5 jour »). Celle de vue-i18n par défaut
 * est l'anglaise, qui met 0 et 1,5 au pluriel. Messages à 3 formes : « aucun | un | plusieurs ».
 */
const french = (choice: number, choicesLength: number): number => {
    const n = Math.abs(choice);
    const index = n < 2 ? 0 : 1;
    if (choicesLength !== 3) return Math.min(index, choicesLength - 1);
    return n === 0 ? 0 : index + 1;
};

export const pluralRules = { fr: french };
